import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appCustomNumericAlpha]'
})

export class CustomNumericAlphaDirective {

  // onlyNumbersRegExp: RegExp = new RegExp('^[\\d.]+$');
  // onlyNumbersRegExp: RegExp = new RegExp('^[A-Z-0-9]');  
  onlyNumbersRegExp: RegExp = new RegExp('^[A-Z0-9]');  

  @HostListener('paste', ['$event']) pasteClipboard(e: ClipboardEvent): boolean {
    const data = e.clipboardData.getData('text');
    return this.onlyNumbersRegExp.test(data) ? true : false;
  }

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent): boolean {
    return (e.ctrlKey || e.metaKey || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 37 || e.keyCode === 39 ||
       e.keyCode === 46 || e.keyCode === 91 || e.keyCode === 93) ? true : this.onlyNumbersRegExp.test(e.key);
  }
  /*
  //^$|^[a-zA-Z0-9]+$
  // onlyAlphanumeric: RegExp = new RegExp('^[a-zA-Z0-9_]*$');
  // onlyAlphanumeric: RegExp = new RegExp('^[A-Za-z0-9 ]+$');
  // ^[0-9,-]+$
  onlyAlphanumeric: RegExp = new RegExp('^[A-Za-zñÑáéíóúÁÉÍÓÚ0-9,_."]+$');
  customAlphanumeric: RegExp = new RegExp('^[A-Za-zñÑáéíóúÁÉÍÓÚ0-9,-_".]+$');
  customAlphanumeric: RegExp = new RegExp('^[A-Z-0-9]');  
  customAlphanumeric: RegExp = new RegExp('^[\\d.]+$');


  // customAlphanumeric: RegExp = new RegExp('^[A-Za-zñÑáéíóúÁÉÍÓÚ(\s)]+$');
  // onlyAlphanumeric: RegExp = new RegExp('^(?:[\u0000-\u007F]+|[\u0370-\u03FF]+)$');


  @HostListener('paste', ['$event']) pasteClipboard(e: ClipboardEvent): boolean {
    const data = e.clipboardData.getData('text');
    return this.customAlphanumeric.test(data) ? true : false;
  }

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent): boolean {
    // return (e.keyCode === 8 || e.keyCode === 32 || e.keyCode === 37 || e.keyCode === 39)
    // ? true : this.customAlphanumeric.test(e.key);
    return (e.ctrlKey || e.metaKey || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 37 || e.keyCode === 39 ||
      e.keyCode === 46 || e.keyCode === 91 || e.keyCode === 93) ? true : this.customAlphanumeric.test(e.key);
  }

  // @HostListener('paste', ['$event']) pasteClipboard(e: ClipboardEvent): boolean {
  //   const data = e.clipboardData.getData('text');
  //   return this.customAlphanumeric.test(data) ? true : false;
  // }
  */
} 
